/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

import EmptyStateBox from 'app/components/commons/EmptyStateBox';
import AdImageLink from 'app/components/commons/AdImageLink';
import ChallengesListHead from 'app/components/challenges/ChallengesListHead';
import ChallengesListBody from 'app/components/challenges/ChallengesListBody';

type Props = {
  ad?: Object,
  challenges: Array<*>,
  columns: Array<*>,
  disableRowClick?: boolean,
  emptyMessage?: string,
  emptyTitle?: string,
  enableDelete?: boolean,
  expandedChallengeId?: string,
  expandType?: 'edit' | 'summary' | 'view',
  isDeletingChallenges?: boolean,
  onCancelClick?: () => void,
  onCheckBoxClick?: challengeId => void,
  onConfirmClick?: () => void,
  onCounterClick?: (challengeId: string, direction: number) => void,
  onDeleteClick?: () => void,
  onExpand?: string => void,
  onNameClick?: string => void,
  onSort?: string => void,
  selectedIds?: Array,
  showChallengeEntryState?: boolean,
  showDelete?: boolean,
  showEnter?: boolean,
  showPlaceholder?: boolean,
  showSportsIcon?: boolean,
  sortDirection?: string,
  sortField?: string,
  title: string,
  isTwoThirdSize?: boolean
};

const AdWrapper = styled.div(({ theme }) => ({
  marginTop: theme.spacing.xsmall
}));

class ChallengesList extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    ad: undefined,
    disableRowClick: false,
    emptyMessage: undefined,
    emptyTitle: undefined,
    enableDelete: false,
    expandedChallengeId: undefined,
    expandType: undefined,
    isDeletingChallenges: false,
    onCancelClick: undefined,
    onCheckBoxClick: undefined,
    onConfirmClick: undefined,
    onCounterClick: undefined,
    onDeleteClick: undefined,
    onExpand: undefined,
    onNameClick: undefined,
    onSort: undefined,
    selectedIds: [],
    showChallengeEntryState: true,
    showDelete: false,
    showEnter: false,
    showPlaceholder: false,
    showSportsIcon: false,
    sortDirection: undefined,
    sortField: undefined,
    isTwoThirdSize: false
  };

  render() {
    const {
      ad,
      challenges,
      columns,
      expandType,
      expandedChallengeId,
      disableRowClick,
      emptyMessage,
      emptyTitle,
      onCheckBoxClick,
      onCounterClick,
      onExpand,
      onNameClick,
      onSort,
      selectedIds,
      showChallengeEntryState,
      showPlaceholder,
      showSportsIcon,
      sortDirection,
      sortField,
      title,
      showDelete,
      showEnter,
      onCancelClick,
      onDeleteClick,
      onConfirmClick,
      enableDelete,
      isDeletingChallenges,
      isTwoThirdSize
    } = this.props;

    if (!showPlaceholder && challenges.length === 0) {
      return null;
    }

    return (
      <div>
        <ChallengesListHead
          columns={columns}
          onSort={onSort}
          size={challenges.length}
          sortDirection={sortDirection}
          sortField={sortField}
          title={title}
          onDeleteClick={onDeleteClick}
          onConfirmClick={onConfirmClick}
          onCancelClick={onCancelClick}
          hasSelectedRows={selectedIds.length > 0}
          showDelete={showDelete}
          showEnter={showEnter}
          enableDelete={false}
          isDeletingChallenges={isDeletingChallenges}
        />
        <ChallengesListBody
          challenges={challenges}
          columns={columns}
          disableRowClick={disableRowClick}
          expandType={expandType}
          expandedChallengeId={expandedChallengeId}
          onCounterClick={onCounterClick}
          onCheckBoxClick={onCheckBoxClick}
          onExpand={onExpand}
          onNameClick={onNameClick}
          selectedIds={selectedIds}
          showChallengeEntryState={showChallengeEntryState}
          showDelete={enableDelete && showDelete}
          showEnter={showEnter}
          showSportsIcon={showSportsIcon}
          isDeletingChallenges={isDeletingChallenges}
          isTwoThirdSize={isTwoThirdSize}
        />
        {challenges.length === 0 && (
          <EmptyStateBox size="small" title={emptyTitle} message={emptyMessage} />
        )}
        {challenges.length > 0 && ad && ad.enabled && (
          <AdWrapper>
            <AdImageLink ad={ad} />
          </AdWrapper>
        )}
      </div>
    );
  }
}

export default ChallengesList;
